import React from 'react';
import ReportSectionPage from '../../../common/components/reports/ReportSectionPage';

const TicketReport = () => {
  return <ReportSectionPage scope="org-admin" section="tickets" title="Ticket Report" />;
};

export default TicketReport;
